var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action"},[_vm._v("\n  "+_vm._s(_vm.$t('showing'))+" "+_vm._s(_vm.startItem)+" - "+_vm._s(_vm.endItem)+" "+_vm._s(_vm.$t('of'))+"\n  "+_vm._s(_vm.totalWorkItems)+" "+_vm._s(_vm.$t('itemsFound'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }